import { createActions } from 'redux-actions';

export const actionCreators = createActions({
  sidebar: {
    toggle: undefined,
  },
  eventHelper: {
    setEvent: undefined,
    resetEvent: undefined,
  },
  company: {
    set: undefined,
    reset: undefined,
    setPrintCopies: undefined,
    toggleAutoPrint: undefined,
    toggleDeliveryEnabled: undefined,
  },
  print: {
    setInnerPrinterConnected: undefined,
    setExternalPrinterConnected: undefined,
    setExternalPrinterStatus: undefined,
  },
});
